import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=ba279e4c"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba279e4c')) {
      api.createRecord('ba279e4c', component.options)
    } else {
      api.reload('ba279e4c', component.options)
    }
    module.hot.accept("./page-footer.vue?vue&type=template&id=ba279e4c", function () {
      api.rerender('ba279e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/page-footer.vue"
export default component.exports